export const columns = [
  {
    accessorKey: "supplierType",
    header: "Supplier Type",
    type: "string",
    size: 180,
  },
  {
    accessorKey: "cnicNumber",
    header: "CNIC #",
    type: "string",
    size: 140,
  },
  {
    accessorKey: "supplierName",
    header: "Supplier Name",
    type: "string",
    size: 190,
  },
  {
    accessorKey: "mobileNumber",
    header: "Mobile #",
    type: "string",
    size: 150,
  },
  {
    accessorKey: "addressDetails",
    header: "Address",
    type: "string",
    size: 150,
  },
  {
    accessorKey: "licenseNumber",
    header: "License #",
    type: "string",
    size: 150,
  },
  {
    accessorKey: "isActive",
    header: "Active",
    type: "boolean",
    size: 130,
  },
  {
    accessorKey: "actions",
    header: "Actions",
    type: "string",
    size: 140,
    accessorFn: (row: any) => ` ${row.actions || " "}`,
  },
];
